import { useEffect, useMemo, useState } from "react";
import { Screen } from "@/components/kit";
import { useLang } from "@/lib/i18n";
import { useSession } from "@/context/SessionContext";
import { verifyDrop } from "@/lib/verify";
import { VerifyInputs } from "@/components/verify/VerifyInputs";
import { VerifyResult } from "@/components/verify/VerifyResult";

export default function VerifyPage() {
  const { t } = useLang();
  const { session: s, patch } = useSession();
  const [ullage, setUllage] = useState(0);
  const [confirmed, setConfirmed] = useState(null);
  const v = useMemo(() => verifyDrop({ start: s.startInches, delivered: s.dropGallons, diameter: s.diameter, capacity: s.capacity, ends: s.ends, ullage }),
    [s.startInches, s.dropGallons, s.diameter, s.capacity, s.ends, ullage]);
  useEffect(() => setConfirmed(null), [v]);
  return (
    <Screen testID="verify-screen" title={t("Quick-verify a drop")} subtitle={t("Check the level before you open the internal valves")}>
      <VerifyInputs s={s} patch={patch} ullage={ullage} setUllage={setUllage} t={t} />
      {s.dropGallons > 0 ? (
        <VerifyResult v={v} ullage={ullage} confirmed={confirmed} t={t}
          onConfirm={() => setConfirmed(new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }))} />
      ) : <div className="card empty-result" data-testid="verify-empty">{t("Type the starting stick and the metered gallons to see the level after the drop.")}</div>}
    </Screen>
  );
}
